<!--
 * @Author: 汪俊洪
 * @Date: 2022-10-18 15:49:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-07-11 11:22:07
 * @Description: 售后服务详情
-->
<template>
  <div class="inner">
    <div class="content top-info">
      <h2 class="title">
        售后服务详情
        <span class="status">{{ $getDictLabel('USER_AFTER_SALES_STATUS', detail.userAfterSalesStatus) }}</span>
      </h2>
      <div class="userAfterSalesCode">
        <span>
          售后单号：{{ detail.userAfterSalesCode }}
        </span>
        <span>
          制单时间：{{ detail.createTime }}
        </span>
      </div>
      <el-button
        type="primary"
        size="small"
        v-if="['1'].includes(detail.userAfterSalesStatus)"
        @click="cancelVisible = true"
        style="margin-right: 12px;"
        >取消单据</el-button
      >
      <el-badge class="ossIdsLen" :value="ossIdsLen > 0 ? ossIdsLen : null">
        <el-button size="small" @click="ossIdsVisible = true">附件</el-button>
      </el-badge>
    </div>
    <div>
      <h2>
        基本信息
      </h2>
      <el-form ref="input" class="form">
        <el-form-item label="订单编号：" style="width: 33.33%">
          {{ detail.orderCode }}
        </el-form-item>
        <el-form-item label="申请人：" style="width: 33.33%">
          {{ detail.userName }}
        </el-form-item>
        <el-form-item label="申请人电话：" style="width: 33.33%">
          {{ detail.userMobile }}
        </el-form-item>
        <el-form-item label="申请类型：" style="width: 100%">
          {{ $getDictLabel('USER_AFTER_SALES_TYPE', detail.userAfterSalesType) }}
        </el-form-item>
        <el-form-item label="申请原因：" style="width: 100%">
          {{ detail.reason }}
        </el-form-item>
        <el-form-item label="取消备注：" v-if="detail.userAfterSalesStatus === '4'" style="width: 100%">
          {{ detail.cancelRemark }}
        </el-form-item>
      </el-form>
      <h2>
        商品明细
      </h2>
      <el-table :data="detail.goodsItemList" border style="width: 100%;">
        <el-table-column
          prop="goodsCode"
          header-align="center"
          align="center"
          label="商品编码"
        >
        </el-table-column>
        <el-table-column
          prop="goodsName"
          header-align="center"
          align="center"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="goodsModel"
          header-align="center"
          align="center"
          label="型号"
        >
        </el-table-column>
        <el-table-column
          prop="transactionPrice"
          header-align="center"
          align="center"
          width="110px"
          label="应付单价"
        >
        </el-table-column>
        <el-table-column
          prop="goodsNum"
          header-align="center"
          align="center"
          label="下单数量"
        ></el-table-column>
        <el-table-column
          prop="deliveryNum"
          header-align="center"
          align="center"
          label="发货数量"
        ></el-table-column>
        <el-table-column
          prop="afterSalesNum"
          header-align="center"
          align="center"
          label="申请数量"
        >
        </el-table-column>
        <el-table-column
          prop="afterSalesAmount"
          header-align="center"
          align="center"
          label="退/补总金额"
          width="150"
        >
        </el-table-column>
      </el-table>
      <div class="title2">
        <h2>备注</h2>
        <el-button style="margin-left: 12px;" size="mini" type="primary" @click="showAdd">添加</el-button>
      </div>
      <el-table :data="detail.remarkList || []" border style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="createUserName"
          header-align="center"
          align="center"
          width="100px"
          label="创建人"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          header-align="center"
          align="center"
          width="160px"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          header-align="center"
          align="left"
          label="备注内容"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- 取消单据 -->
    <el-dialog
      title="取消单据"
      :visible.sync="cancelVisible"
      width="667px"
    >
      <CancelOrder
        v-if="cancelVisible"
        @submit="cancelOrder"
        @close="cancelVisible = false"
      />
    </el-dialog>
    <!-- 附件 -->
    <el-dialog
      :visible.sync="ossIdsVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="附件"
      width="773px"
    >
      <Enclosure
        v-if="ossIdsVisible"
        :isAdd="false"
        :showUpload="!['4', '5'].includes(detail.userAfterSalesStatus)"
        :enclosureInfo="enclosureInfo"
        @cancel="ossIdsVisible = false"
        @afterSearch="v => (ossIdsLen = v)"
      />
    </el-dialog>
    <el-dialog
      title="添加备注"
      width="667px"
      append-to-body
      :visible.sync="addVisible"
    >
      <AddRemark
        v-if="addVisible"
        :userAfterSalesCode="detail.userAfterSalesCode"
        @success="success"
        @cancel="addVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import Enclosure from '@/components/enclosure/index.vue'
import CancelOrder from './components/cancelOrder.vue'
import AddRemark from './components/addRemark.vue'
export default {
  components: {
    CancelOrder,
    Enclosure,
    AddRemark
  },
  data () {
    return {
      detail: {},
      cancelVisible: false,
      enclosureInfo: {
        searchUrl: '/help/consumer/common/omsOrderfile/list',
        addUrl: '/help/consumer/common/omsOrderfile/add',
        deleteUrl: '/help/consumer/common/omsOrderfile/delete',
        extra: {
          businessId: '',
          businessType: '10'
        },
        listAliOssKey: 'id'
      },
      ossIdsVisible: false,
      ossIdsLen: 0,
      addVisible: false
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    // 新增成功
    success () {
      this.getDetail()
      this.addVisible = false
    },
    showAdd () {
      this.addVisible = true
    },
    getDetail () {
      let obj = {
        id: this.$route.query.id,
        userAfterSalesCode: this.$route.query.userAfterSalesCode
      }
      this.$http.post('/front/consumer/userAfterSales/info', obj).then(({ data: res }) => {
        if (res.code === 0) {
          this.detail = res.data
          this.enclosureInfo.extra.businessId = this.detail.id
          if (this.detail.orderFileVos) {
            this.ossIdsLen = this.detail.orderFileVos.length
          }
        }
      })
    },
    // 取消单据
    cancelOrder (input) {
      const obj = {
        id: this.detail.id,
        ...input
      }
      this.$http
        .post('/front/consumer/userAfterSales/cancel', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.cancelVisible = false
            this.getDetail()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.form {
  display: flex;
  flex-wrap: wrap;
}

.title {
  display: flex;
  .status {
    margin-left: 12px;
    padding: 0 5px;
    line-height: 39px;
    font-size: 14px;
    color: rgb(26, 188, 156);
    border: 1px solid rgb(26, 188, 156);
    border-radius: 4px;
  }
}

.userAfterSalesCode {
  padding-bottom: 12px;
  span {
    margin-right: 12px;
  }
}
.title2 {
  display: flex;
  font-size: 16px;
  align-items: center;
}
</style>
